import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

let cache = {
  key: null,
  data: null,
  timestamp: 0,
};
const CACHE_TTL_MS = 2 * 60 * 1000; // 2 minutos

const buildCacheKey = (groupOrContext) => {
  if (!groupOrContext) return null;
  const context =
    typeof groupOrContext === 'object'
      ? groupOrContext
      : { groupId: groupOrContext };
  return `${context.requestedApp || 'dealership_web'}_${context.groupId || ''}_${context.dealershipId || ''}_${context.operatingUnitId || ''}`;
};

export const getCachedResellersByGroup = (groupOrContext) => {
  const key = buildCacheKey(groupOrContext);
  if (!key) return null;
  if (cache.key === key && cache.data && Date.now() - cache.timestamp < CACHE_TTL_MS) {
    return cache.data;
  }
  return null;
};

export const updateCachedResellers = (userId, updatedFields) => {
  if (!cache.data || !Array.isArray(cache.data.data)) return;
  cache.data = {
    ...cache.data,
    data: cache.data.data.map((r) =>
      r.id === userId ? { ...r, ...updatedFields } : r
    ),
  };
};

export const clearResellersCache = () => {
  cache = { key: null, data: null, timestamp: 0 };
};

export const getResellersByGroup = async (groupOrContext, options = {}) => {
  if (groupOrContext === null) {
    return;
  }

  const { forceRefresh = false } = options;
  const key = buildCacheKey(groupOrContext);

  if (!forceRefresh && key && cache.key === key && cache.data && Date.now() - cache.timestamp < CACHE_TTL_MS) {
    return cache.data;
  }

  try {
    const getResellersByGroupFn = httpsCallable(functions, 'getResellersByGroupV2');
    const context =
      typeof groupOrContext === 'object'
        ? groupOrContext
        : { groupId: groupOrContext };
    const result = await getResellersByGroupFn({
      ...context,
      requestedApp: context.requestedApp || 'dealership_web',
    });
    if (result?.data?.success === 'yes' && Array.isArray(result.data?.data)) {
      cache = {
        key,
        data: result.data,
        timestamp: Date.now(),
      };
    }
    return result.data;
  } catch (error) {
    console.error('Error obteniendo resellers por grupo:', error);
    notifyPermissionDenied(error);
    return { success: 'no', message: error.message };
  }
};
